module.exports = __webpack_public_path__ + "img/product_hero.f7faace2.jpg";